/**
 * Wall-clock HH:mm (24-hour) in the user's local timezone from an ISO instant.
 */
export function formatTime24(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/**
 * Parse user-entered time into HH:mm (24h). Accepts "9", "9:30", "09:30".
 */
export function parseFlexibleTime24(input: string): string | null {
  const s = input.trim();
  if (!s) return null;
  const parts = s.split(":");
  if (parts.length === 1) {
    const h = Number(parts[0]);
    if (!Number.isInteger(h) || h < 0 || h > 23) return null;
    return `${String(h).padStart(2, "0")}:00`;
  }
  if (parts.length === 2) {
    const h = Number(parts[0]);
    const m = Number(parts[1]);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
    if (!Number.isInteger(h) || h < 0 || h > 23) return null;
    if (!Number.isInteger(m) || m < 0 || m > 59) return null;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  }
  return null;
}
